import { useState } from 'react';
import { ArrowUp, Square } from 'lucide-react';
import { SleepingBuffalo } from './BuffaloSprites';
import BuffyStatusSprite from './BuffyStatusSprite';
import ChatTextInput from './ChatTextInput';
import '../assets/buffalo-ui/status/buffy-status.css';
import './BuffyComposer.css';

// gathering (Sandy 2026-09-23): while Buffy collects class data or works on a
// question, the gathering-data sprite takes the sleeping/standing Buffy's place.
// onCancel (W4-B): while a reply is on its way, the send button becomes Cancel
// and stops it. The box stays open for the next question.
// buffy false (Sandy 2026-10-21, the docked chat on every page but Home): no
// Buffy beside the box, and the box is the short one (.is-plain).
export default function BuffyComposer({ value, onChange, onSubmit, onCancel = null, placeholder = 'Ask Buffy about your class…', label = 'Ask Buffy', sendLabel = 'Send message', maxLength, busy = false, disabled = false, hasConversation = false, gathering = false, multiline = false, buffy = true, children }) {
  const [focused, setFocused] = useState(false);
  // multiline (2026-10-07, admin chats): a box that keeps pasted line breaks
  // (ChatTextInput); Enter still sends. Without it, the one-line input as before.
  const Field = multiline ? ChatTextInput : 'input';
  return <div className={`th-composer-scene buffy-composer-scene${buffy ? '' : ' is-plain'}`}>
    {!buffy ? null : gathering ? <BuffyStatusSprite state="gathering-blue" className="buffalo-gatherer" />
      : <SleepingBuffalo awake={focused || busy || hasConversation} />}
    {children}
    <form className="th-composer" onSubmit={onSubmit}>
      <Field aria-label={label} value={value} onChange={onChange} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
        maxLength={maxLength} placeholder={placeholder} disabled={disabled || busy} />
      {onCancel
        ? <button type="button" className="th-send th-cancel" aria-label="Cancel the reply" title="Cancel" onClick={onCancel}><Square size={15} fill="currentColor" /></button>
        : <button type="submit" className="th-send" aria-label={sendLabel} disabled={disabled || busy || !value.trim()}><ArrowUp size={19} /></button>}
    </form>
  </div>;
}
